import request from '@/services/interceptor.js'

export const get_manutenzioni = (filtri) => {
    return request({
        url: '/manutenzione',
        method: 'get',
        params: filtri || {},
        loadingBar: true
    })
}

export const get_manutenzione = (id) => {
    return request({
        url: `/manutenzione/${id}`,
        method: 'get',
        loadingBar: true
    })
}

export const create_manutenzione = (par) => {
    return request({
        url: '/manutenzione',
        method: 'post',
        data: par,
        loadingBar: true
    })
}

export const update_manutenzione = (id, par) => {
    return request({
        url: `/manutenzione/${id}`,
        method: 'put',
        data: par,
        loadingBar: true
    })
}

export const inizia_manutenzione = (id) => {
    return request({
        url: `/manutenzione/${id}/inizia`,
        method: 'post',
        loadingBar: true
    })
}

export const completa_manutenzione = (id, par) => {
    return request({
        url: `/manutenzione/${id}/completa`,
        method: 'post',
        data: par,
        loadingBar: true
    })
}

export const modifica_ricambi_manutenzione = (id, par) => {
    return request({
        url: `/manutenzione/${id}/ricambi`,
        method: 'put',
        data: par,
        loadingBar: true
    })
}

export const duplica_manutenzione = (id) => {
    return request({
        url: `/manutenzione/${id}/duplica`,
        method: 'post',
        loadingBar: true
    })
}

export const elimina_manutenzione = (id, ripristinaMagazzino) => {
    return request({
        url: `/manutenzione/${id}`,
        method: 'delete',
        data: { ripristinaMagazzino: !!ripristinaMagazzino },
        loadingBar: true
    })
}